import useRequest from "../helpers/http/useRequest";

export async function getEstados() {
    return useRequest.get(`/external/estado`);
}

export async function getMunicipiosByEstadoID(codEstado) {
    return useRequest.get(`/external/municipio/estado/${codEstado}`);
}